import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import moment from "moment";

// External components
import SubscriptionMenusQuantities from "@/components/subscriptionMenusQuantities/subscriptionMenusQuantities";
import ApplyCouponInput from "@/components/applyCouponInput/applyCouponInput";
// Helpers
import {
  getWeekDayByCreationWeekDayNumber,
  getNextDeliveryDateByCreationWeekDay,
} from "@/plugins/schedules_helper";
import { paymentMethodToSpanish } from "@/plugins/payment_helper";
import { localCurrency } from "@/plugins/currency";

@Component({
  components: { SubscriptionMenusQuantities, ApplyCouponInput },
  methods: { moment, paymentMethodToSpanish, localCurrency },
})
export default class OnBoardingStep3 extends Vue {
  @Prop({ default: false }) isGoingToNextStep;

  @Action action_updateSubscription;

  @Getter getSubscription;
  @Getter getUser;
  @Getter getCity;
  @Getter getIsUnderMobile;

  @Mutation SPINNER;

  comments = null;

  get getCreationWeekDay() {
    const { creation_week_day } = this.getSubscription;
    const { name } = getWeekDayByCreationWeekDayNumber(creation_week_day);
    return name.charAt(0).toUpperCase() + name.slice(1);
  }

  get getSubscriptionAddress() {
    const { addresses } = this.getUser;
    const address = addresses.find((address) => address.id === this.getSubscription.address_id);
    if (address) {
      return `${address.address}, ${address.address_info}`;
    }
    return "No address found!";
  }

  get getNextDeliveryDay() {
    const { creation_week_day } = this.getSubscription;
    return getNextDeliveryDateByCreationWeekDay(creation_week_day);
  }

  get getDonationTotal() {
    const { total } = this.getSubscription;
    return parseFloat(total) * 0.07;
  }

  mounted() {
    this.setInitialValues();
  }

  @Watch("isGoingToNextStep")
  onIsGoingToNextStepChange() {
    if (this.isGoingToNextStep) {
      this.startPlan();
      this.$emit("change-is-going-to-next-step");
    }
  }

  setInitialValues() {
    const { comments } = this.getSubscription;
    this.comments = comments;
  }

  async startPlan() {
    const payload = {
      commerceId: this.getCity.id,
      subscriptionId: this.getSubscription.id,
      subscription: {
        subscription: {
          comments: this.comments,
          status: "active",
        },
      },
    };
    try {
      this.SPINNER(true);
      await this.action_updateSubscription(payload);
      this.$router.replace({ name: "subscriptionDashboard" });
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Hubo un error al comenzar el plan. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
    this.SPINNER(false);
  }
}
